import React, { Fragment, useEffect, useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import country_currency from "./country_currency.json";
import API from './API';

function Event() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueImage, setIsTrueIMg] = React.useState(false);  
  const [isTrueStrwamUrl, setIsStreamUrl] = React.useState(false);  
  const [isTrueOfferUrl, setIsTrueOfferUrl] = React.useState([{status:'false', index: 0 }]);
  const [zonePost, setZonePost]= useState([]);
  const [countryData, setCountryData]= useState([]);
  const [stateData, setStateData]= useState([]);
  const [inputFieldsEv1, setInputFieldsEv1] = useState({
    type: "ListItem",
    position: 1,
    name: '',
    description: '',
    image:'',
    startDate:'',
    endDate:'',
    starttime:'',
    endtime:'',
    eventStatus:'',
    eventAttend:'',
    vennuname:'',
    streetAddress:'',
    city:'',
    stream_url:'',
    statepresgion:'',
    performerName:'',
    zipcode:'',
    country:'',
    currency:'',
    performer:'',

  })
  const [inputFieldsEv, setInputFieldsEv] = useState([])

  useEffect(() => {
    API.getData().then((response) => {
      setZonePost(response.data);
    });
    API.getCountryState().then((response) => {
      setCountryData(response.data);
    });
  }, []);
  
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name === 'image'){
      let isTrueImage = !value || urlPatternValidation(value);
      if(isTrueImage === false)
      {
        setIsTrueIMg(true);
      }
      else{
        setIsTrueIMg(false);
      }
    }
    if(name === 'stream_url'){
      let isTrueSteamurl = !value || urlPatternValidation(value);
      if(isTrueSteamurl === false)
      {
        setIsStreamUrl(true);
      }
      else{
        setIsStreamUrl(false);
      }
    }
    setInputFieldsEv1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
    if(name=== 'country')
    {
      countryData.data.map(function(item, i){
        if(item.iso2 === value)
        {
          setStateData((prevState) => ({
            ...prevState,
            data: item.states
          }));
        }
       return item;
      })
    }
  }
  const handleChange2 = (indexs, evnt) => {
    const { name, value } = evnt.target;
    //isTrueOfferUrl
    if(name === 'offerurl'){
      let isTrueOfferUrl = !value || urlPatternValidation(value);
      if(isTrueOfferUrl === false)
      {
        setIsTrueOfferUrl({status:true, index:indexs});
      }
      else{
        setIsTrueOfferUrl({status:false, index:indexs});
      }
    }
    const list = [...inputFieldsEv];
    list[indexs][name] = value;
    setInputFieldsEv(list);
  } 
  function MyButton(props) {
    return <button {...props} />
  }
    
  const addInputFieldEv = () => {
    setInputFieldsEv([...inputFieldsEv, {
      offername: '',
      offerprice: '',
      offervalidFrom: '',
      offerurl:'',
      offerAvaiability:'',
    }]) 
  }
  const removeInputFieldsEv = (index) => {
    const rows = [...inputFieldsEv];
    rows.splice(index, 1);
    setInputFieldsEv(rows);
  } 
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
  
  const performers = (inputFieldsEv1.performer !== 'None') ? `"performer": {
    "@type": "`+inputFieldsEv1.performer+`",
    "name": "`+inputFieldsEv1.performerName+`"
  },`:'';
  const addressRegion  =(inputFieldsEv1.statepresgion) ? `"addressRegion": "`+inputFieldsEv1.statepresgion+`",`:'';
  const mixed = (inputFieldsEv1.eventAttend === 'Mixed') ? `"location": [{
    "@type": "VirtualLocation",
    "url": "`+inputFieldsEv1.stream_url+`"
  },{		
    "@type": "Place",
    "name": "",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "`+inputFieldsEv1.vennuname+`",
      "addressLocality": "`+inputFieldsEv1.city+`",
      `+addressRegion+`
      "postalCode": "`+inputFieldsEv1.zipcode+`",
      "addressCountry": "`+inputFieldsEv1.country+`"
    }
  }]",` : (inputFieldsEv1.eventAttend === 'Online') ?`"location": {
    "@type": "VirtualLocation",
    "url": "`+inputFieldsEv1.stream_url+`"
  },`:`"location": {		
    "@type": "Place",
    "name": "`+inputFieldsEv1.vennuname+`",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "`+inputFieldsEv1.vennuname+`",
      "addressLocality": "`+inputFieldsEv1.city+`",
      `+addressRegion+`
      "postalCode": "`+inputFieldsEv1.zipcode+`",
      "addressCountry": "`+inputFieldsEv1.country+`"
    }
  },`;

  const startTTime = (inputFieldsEv1.starttime)? 'T'+inputFieldsEv1.starttime:'';
  const endTTime = (inputFieldsEv1.endtime)? 'T'+inputFieldsEv1.endtime:'';
  const offers = (inputFieldsEv.length === 1)?
   `"offers": {
    "@type": "Offer",
    "name": "`+inputFieldsEv[0].offername+`",
    "priceCurrency": "`+inputFieldsEv1.currency+`",
    "validFrom": "`+inputFieldsEv[0].offervalidFrom+`",
    "url": "`+inputFieldsEv[0].offerurl+`",
    "availability": "`+inputFieldsEv[0].offerAvaiability+`"
  }`:`"offers":[`+
  inputFieldsEv.map((items, indd) =>
    //JSON.stringify(items)
    `{
      "@type": "Offer",
      "name": "`+items.offername+`",
      "price": "`+items.offerprice+`",
      "priceCurrency": "`+inputFieldsEv1.currency+`",
      "validFrom": "`+items.offervalidFrom+`",
      "url": "`+items.offerurl+`",
      "availability": "`+items.offerAvaiability+`"
    }`
  )
  + `]`;
  const EvIsMyCopy = `<script type="application/ld+json">
  {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "`+inputFieldsEv1.name+`",
      "description": "`+inputFieldsEv1.description+`",
      "image": "`+inputFieldsEv1.image+`",
      "startDate": "`+inputFieldsEv1.startDate+``+startTTime+`",
      "endDate": "`+inputFieldsEv1.endDate+``+endTTime+`",
      "eventStatus": "https://schema.org/Event`+inputFieldsEv1.eventStatus+`",
      "eventAttendanceMode": "https://schema.org/`+inputFieldsEv1.eventAttend+`EventAttendanceMode",
      `+mixed+`
      `+performers+`
      `+offers+`
  }
  </script><!--EventList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;

  const resetFun = ()=>{
    const swsdata = {
      type: "ListItem",
      position: 1,
      name: '',
      description: '',
      image:'',
      startDate:'',
      endDate:'',
      starttime:'',
      endtime:'',
      eventStatus:'',
      eventAttend:'',
      vennuname:'',
      streetAddress:'',
      city:'',
      stream_url:'',
      statepresgion:'',
      performerName:'',
      zipcode:'',
      country:'',
      currency:'',
      performers:'',
  
    };
    setInputFieldsEv1(swsdata);
    setInputFieldsEv([]);
  }
 
  return (
    <div className='container-flude'> 
        <div className='row mt-5 event_row'>
          <div className='col-md-8 mb-5 border ps-0'>
            <div className='mt-2 mb-2 article_title'><b> <i className="fa-solid fa-calendar-day me-2"></i> Event</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-12">
                  <label>Name</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.name} name="name" className="form-control" />
                  </div>
                </div>
                <div className="col-12">
                  <label>Event's Description</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)}  value={inputFieldsEv1.description} name="description" className="form-control" />
                  </div>
                </div>
                <div className="col-12">
                  <label>Image URL</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.image} name="image" className="form-control" />
                  </div>
                  {isTrueImage && (
                    <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                  )}
                </div>
                <div className="col-6 pe-0 mt-3">
                  <label><i className="fa-solid fa-calendar-week mb-2 ms-1"></i> Start Date</label>
                  <div className="form-group me-2 mb-2">
                    <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.startDate} name="startDate" className="form-control" placeholder="Start Date" />
                  </div>
                </div>
                <div className="col-6 ps-0 mt-3">
                  <label><i className="fa-solid fa-clock mb-2 ms-1"></i> Start Time</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.starttime} name="starttime" className="form-control" placeholder="10:10AM" />
                  </div>
                </div>
                <div className="col-6 pe-0 mt-3">
                  <label><i className="fa-solid fa-calendar-week mb-2 ms-1"></i> End Date</label>
                  <div className="form-group me-2 mb-2">
                    <input type="date" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.endDate} name="endDate" className="form-control" placeholder="" />
                  </div>
                </div>
                <div className="col-6 ps-0 mt-3">
                  <label><i className="fa-solid fa-clock mb-2 ms-1"></i> End Time</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.endtime} name="endtime" className="form-control" placeholder="10:10PM" />
                  </div>
                </div>
                <div className="col-6 pe-0">
                  <label>Event Status</label>
                  <div className="form-group me-2 mb-2">
                    <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="eventStatus" value={inputFieldsEv1.eventStatus}>
                      <option>
                        Select
                      </option>
                      <option value="Scheduled">
                        Scheduled
                      </option>
                      <option value="Postponed">
                        Postponed
                      </option>
                      <option value="Cancelled">
                        Cancelled
                      </option>
                      <option value="Moved Online">
                        Moved Online
                      </option>
                      <option value="None">
                      None
                      </option>
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <label>Attendance Mode</label>
                  <div className="form-group me-2 mb-2">
                    <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="eventAttend" value={inputFieldsEv1.eventAttend}>
                      <option>
                        Select
                      </option>
                      <option value="Online">
                        Online
                      </option>
                      <option value="Offline">
                        Offline
                      </option>
                      <option value="Mixed">
                        Mixed
                      </option>
                    </select>
                    <i className="fa-solid fa-chevron-down"></i>
                  </div>
                </div>
                {(inputFieldsEv1.eventAttend ==='Online' || inputFieldsEv1.eventAttend ==='Mixed') && 
                <Fragment>
                  <div className="col-6">
                    <label>Stream URL</label>
                    <div className="form-group me-2 mb-2">
                      <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.stream_url} name="stream_url" className="form-control" placeholder="Stream URL" />
                      {isTrueStrwamUrl && 
                        <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                      }
                    </div>
                  </div>
                  <div className="col-6">
                    <label>Time Zone</label>
                    <div className="form-group me-2 mb-2">
                      <select onChange={(evnt) => handleChange5(evnt)} className='form-control' name="timezone" value={inputFieldsEv1.timezone}>
                        <option>
                          Select Time Zone
                        </option>
                        {zonePost && 
                          zonePost.map((data, index) => {
                            return <option key={index} value={data}>{data}</option>
                          })
                        
                        }
                      </select>
                    </div>
                  </div>
                  </Fragment>
                }
                {(inputFieldsEv1.eventAttend ==='Offline' || inputFieldsEv1.eventAttend ==='Mixed') && 
                <Fragment>
                  <div className="col-6">
                    <label>Vennu's name</label>
                    <div className="form-group me-2 mb-2">
                      <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.vennuname} name="vennuname" className="form-control" placeholder="Venue's Name" />
                    </div>
                  </div>
                  <div className="col-6">
                    <label>Street Address</label>
                    <div className="form-group me-2 mb-2">
                      <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.streetAddress} name="streetAddress" className="form-control" placeholder="Street" />
                    </div>
                  </div>
                  <div className="col-6">
                    <label>City</label>
                    <div className="form-group me-2 mb-2">
                      <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.city} name="city" className="form-control" placeholder="City" />
                    </div>
                  </div>
                  <div className="col-6">
                    <label>State/Province/Region</label>
                    <div className="form-group me-2 mb-2">
                      <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.statepresgion} name="statepresgion" className='form-control'>
                        <option>
                          Select State/Province/Region
                        </option>
                         {stateData.data && stateData.data.map((data, index) => {
                            return <option key={index} value={data.name}>{data.name}</option>
                          })
                         }
                      </select>
                    </div>
                  </div>
                  <div className="col-6">
                    <label>Zip code</label>
                    <div className="form-group me-2 mb-2">
                      <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.zipcode} name="zipcode" className="form-control" placeholder="Zip code" />
                    </div>
                  </div>
                  <div className="col-6">
                    <label>Country</label>
                    <div className="form-group me-2 mb-2">
                      <select className='form-control'  onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.country} name="country">
                        <option>
                          Select Country
                        </option>
                        { country_currency.countries.country.map((calculatedata, index) => {
                            return (
                                <option key={index} value={calculatedata.countryCode}>
                                    {calculatedata.countryName} 
                                </option>)})
                        }
                      </select>
                    </div>
                  </div>
                  </Fragment>
                }
                <div className="col-12">
                  <label>Performer @type</label>
                  <div className="form-group me-2 mb-2">
                    <select className='form-control'  onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.performer} name="performer">
                      <option value="Person">
                        Person
                      </option>
                      <option value="Performing Group">
                        Performing Group
                      </option>
                      <option value="Music Group">
                        Music Group
                      </option>
                      <option value="Dance Group">
                        Dance Group
                      </option>
                      <option value="Theater Group">
                        Theater Group
                      </option>
                      <option value="None">
                        None
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col-12">
                    <label>Performer's Name</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.performerName} name="performerName" className="form-control" placeholder="Performer's Name" />
                  </div>
                </div>
                <div className="col-6">
                    <label>Currency</label>
                  <div className="form-group me-2 mb-2">
                    <select className='form-control' name="currency" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.currency}>
                      <option value="">
                        Select Currency
                      </option>
                      { country_currency.countries.country.map((calculatedata, index) => {
                          return (
                              <option key={index} value={calculatedata.currencyCode}>
                                  {calculatedata.countryName} {calculatedata.currencyCode}
                              </option>)})
                      }
                    </select>
                  </div>
                </div>
              </div>
            { 
              inputFieldsEv.map((data, index) => {
                const { offername,offervalidFrom,offerurl,offerAvaiability,offerprice } = data;
                return (
                  <div className="input_fields d-flex row" key={index}>
                    <div className='col-12'>
                        {index === 0 && <h3>Tickets</h3>}
                        <h5>Ticket {index+1}</h5>
                    </div>
                    <div className="col-4">
                      <label>Name</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={offername} name="offername" className="form-control" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-4">
                      <label>Price</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={offerprice} name="offerprice" className="form-control" placeholder="Price" />
                      </div>
                    </div>
                    <div className="col-4">
                      <label>Valid From</label>
                      <div className="form-group me-2 mb-2">
                        <input type="date" onChange={(evnt) => handleChange2(index, evnt)} value={offervalidFrom} name="offervalidFrom" className="form-control" placeholder="validFrom" />
                      </div>
                    </div>                     
                    <div className="col-4">
                      <label>URL</label>
                      <div className="form-group me-2 mb-2">
                        <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={offerurl} name="offerurl" className="form-control" placeholder="URL" />
                      </div>
                      {(isTrueOfferUrl['status'] && isTrueOfferUrl['index'] === index) && (
                        <div style={{ color: "#F61C04" }}>Invalid URL.</div>
                      )}
                    </div>
                    <div className="col-4">
                      <label>Availability</label>
                      <div className="form-group me-2 mb-2">
                        <select className='form-control' onChange={(evnt) => handleChange2(index, evnt)} value={offerAvaiability} name="offerAvaiability">
                          <option>
                            Select Availability
                          </option>
                          <option value="In Stock">
                            In Stock
                          </option>
                          <option value="Sold Out">
                            Sold Out
                          </option>
                          <option value="Pre-order">
                            Pre-order
                          </option>
                          <option value="Not specified">
                            Not specified
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-2 d-flex text-center justify-content-center align-items-end">
                      {(inputFieldsEv.length !== 1) ? <button className="btn btn-outline-danger dltbtn mb-2" onClick={()=>removeInputFieldsEv(index)}> <i className="fa-solid fa-minus"></i> </button> : ''}
                    </div>
                  </div>
                )
              })
            }
            <div className="col mt-3 mb-3">
              <button className="btn btn-outline-success addticket" onClick={addInputFieldEv}> <i className="fa-solid fa-plus"></i> Add Ticket</button>
            </div>  
          </div>
          <div className='col-md-4 ps-4'>
            <div className="card">
              <div className="card-header d-flex">
                <CopyToClipboard onCopy={onCopy} text={EvIsMyCopy} >
                  <MyButton className="btn btn-success"> <i className="fa-solid fa-copy"></i> Copy</MyButton>
                </CopyToClipboard>
                 
                  <MyButton className="btn btn-success" onClick={()=>resetFun()}> <i className="fa-solid fa-arrows-rotate me-1"></i> Reset</MyButton> 
              </div>
              <div className="card-body">
                {EvIsMyCopy}
              </div>
              {copied && 
                <div className="card-footer text-muted">
                  <div className="p-2 btn-success rounded">✅ copied successfully</div>
                </div>
              }
            </div>
          </div>
        </div> 
    </div>
  );
}

export default Event